import { render } from "./values_list.vue?vue&type=template&id=538ddd8e"
import script from "./values_list.vue?vue&type=script&lang=js"
export * from "./values_list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__